import React, { Component } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import VideoFeature from '../components/cards/video-feature'
import VideoCard from '../components/cards/video'

class KolloscheTv extends Component {

  state = {
    filteredPosts: this.props.data.videos.edges,
    count: this.props.data.videos.edges.length,
    filter: 'All',
  }

  filterPosts = (filter, set = true) => {
    let filteredPosts = this.props.data.videos.edges
    let match = false
    if (filter !== 'All') {
      filteredPosts = filteredPosts.filter((post) => {
        const categories = post.node.acf.categories
        match = false
        categories.forEach((el, i) => {
          if (el === filter) match = true
        })
        return match
      })
    }

    if (set) {
      this.setState({
        filteredPosts,
        filter,
        count: filteredPosts.length,
      })
    }

    return filteredPosts
  }

  render() {

    let page = this.props.data.wpPage
    let { videos } = this.props.data
    let { count, filter, filteredPosts } = this.state

    return (
      <>
        { videos.edges.length > 0 && 
          <section className='tv-grid'>
            <div className='tv-grid__inner'>
              <div className='tv-grid__header'>
                <h4>Displaying<br /><strong>{count} Results</strong></h4>
              </div>
              <div className='tv-grid__items'>
                { filteredPosts.map((el, i) => (
                  <div className='tv-grid__item' key={i}>
                    <VideoCard {...el.node} />
                  </div>
                )) }
              </div>
            </div>
          </section>
        }
      </>
    )
  }
}

export default function TvQuery(props) {
  return (
    <StaticQuery
      query={graphql`
        query TvQuery {
          videos: allWpVideo {
            edges {
              node {
                title
                content
                date(formatString: "MMMM Do YYYY")
                featuredImage {
                  node {
                    sourceUrl
altText
                  }
                }
                acf {
                  video
                  categories
                  tags
                }
              }
            }
          }
        }
      `}
      render={data => (
        <KolloscheTv data={data} {...props} />
      )}
    />
  )
}